import { Link } from "react-router";
import { Stack, Flex, Box, Group, Button } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { LOGO_BACKGROUND_RGB, MOBILE_VIEW_MAX_WIDTH_EM } from "../Settings";

type ButtonLinkProps = {
  to: string;
  text: string;
  isMobile?: boolean | undefined;
};

export default function Landing() {
  const isMobile = useMediaQuery(`(max-width: ${MOBILE_VIEW_MAX_WIDTH_EM})`);

  const ButtonLink: React.FC<ButtonLinkProps> = ({ to, text, isMobile }) => {
    return (
      <Link to={to}>
        <Button variant="filled" size={isMobile ? "sm" : "md"}>
          {text}
        </Button>
      </Link>
    );
  };

  return (
    <Flex
      gap="md"
      justify="center"
      align="center"
      direction="column"
      style={{ height: "calc(100vh - 130px)" }}
    >
      <Box
        w={{ base: "300px", sm: "400px" }}
        p="md"
        style={{
          backgroundColor: LOGO_BACKGROUND_RGB,
        }}
      >
        <Stack align="center">
          <a
            href="https://www.greate-escape-sports.org"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/ges-health-logo.png"
              alt="Horse Pulse"
              style={{
                width: "224px",
                height: "112px",
              }}
            />
          </a>
          <Group gap={isMobile ? "md" : "lg"} justify="flex-end" wrap="nowrap">
            <ButtonLink to="/account/login" text="Login" />
            <ButtonLink to="/account/signup" text="Signup" />
          </Group>
        </Stack>
      </Box>
    </Flex>
  );
}
